import React, { useState } from "react";
import "./demande.css";
import { useTranslation } from 'react-i18next';
import { FaUserFriends, FaChild, FaBaby, FaMinus, FaPlus, FaArrowLeft, FaArrowRight, FaCalendarAlt, FaCheckCircle } from 'react-icons/fa';

export default function Demande({
  onNext, onBack, setAdults, setChildren, setBebe,
  maxAdults = 9, maxChildren = 9,
  departures = [], selectedDepart, selectedArrivage, onDateSelect
}) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const locale = isRTL ? 'ar-DZ' : 'fr-FR';
  const [localAdults, setLocalAdults] = useState(1);
  const [localChildren, setLocalChildren] = useState(0);
  const [localBebe, setLocalBebe] = useState(0);

  const handleNext = () => {
    setAdults(localAdults);
    setChildren(localChildren);
    setBebe(localBebe);
    onNext();
  };

  const Counter = ({ value, onChange, min = 0, max = 9, icon, label, subtitle }) => (
    <div className="dm-counter-card">
      <div className="dm-counter-info">
        <div className="dm-counter-icon">{icon}</div>
        <div>
          <div className="dm-counter-label">{label}</div>
          {subtitle && <div className="dm-counter-subtitle">{subtitle}</div>}
        </div>
      </div>
      <div className="dm-counter-controls">
        <button
          className="dm-counter-btn"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
        >
          <FaMinus />
        </button>
        <span className="dm-counter-value">{value}</span>
        <button
          className="dm-counter-btn"
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
        >
          <FaPlus />
        </button>
      </div>
    </div>
  );

  const totalPassengers = localAdults + localChildren + localBebe;

  return (
    <div className={`dm-section ${isRTL ? 'rtl' : ''}`}>
      {/* Date Selection */}
      {departures.length > 0 && (
        <>
          <h2 className="dm-title">
            <FaCalendarAlt className="dm-title-icon" />
            {isRTL ? "اختر تاريخ السفر" : "Choisissez votre date"}
          </h2>
          <div className="dm-date-options">
            {departures.map((dep, i) => {
              const start = new Date(dep.start);
              const end = new Date(dep.end);
              const days = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
              const nights = days > 0 ? days - 1 : 0;
              const isSelected = selectedDepart === dep.start && selectedArrivage === dep.end;
              return (
                <div
                  key={i}
                  className={`dm-date-option ${isSelected ? "selected" : ""}`}
                  onClick={() => onDateSelect(dep)}
                >
                  {isSelected && <FaCheckCircle className="dm-date-check" />}
                  <div className="dm-date-range">
                    <span className="dm-date-val">{start.toLocaleDateString(locale, { day: "numeric", month: "short" })}</span>
                    <span className="dm-date-arrow">&rarr;</span>
                    <span className="dm-date-val">{end.toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" })}</span>
                  </div>
                  <span className="dm-date-duration">{days}j / {nights}n</span>
                </div>
              );
            })}
          </div>
          <div className="dm-divider" />
        </>
      )}

      {/* Passengers */}
      <h2 className="dm-title">{t("demande.title")}</h2>
      <p className="dm-subtitle">{t("demande.explanatory_text")}</p>

      <div className="dm-capacity">
        <span className="dm-capacity__label">
          {isRTL ? "السعة القصوى" : "Capacité max"} :
        </span>
        <span className="dm-capacity__chip"><FaUserFriends /> {maxAdults} {isRTL ? "بالغ" : "adultes"}</span>
        <span className="dm-capacity__chip"><FaChild /> {maxChildren} {isRTL ? "طفل/رضيع" : "enfants/bébés"}</span>
      </div>

      <div className="dm-counters">
        <Counter
          value={localAdults}
          onChange={setLocalAdults}
          min={1}
          max={maxAdults}
          icon={<FaUserFriends />}
          label={t("demande.adults_label")}
          subtitle={`+12 ans · max ${maxAdults}`}
        />
        <Counter
          value={localChildren}
          onChange={setLocalChildren}
          max={maxChildren - localBebe}
          icon={<FaChild />}
          label={t("demande.children_label")}
          subtitle={`2-12 ans · max ${maxChildren - localBebe}`}
        />
        <Counter
          value={localBebe}
          onChange={setLocalBebe}
          max={maxChildren - localChildren}
          icon={<FaBaby />}
          label={t("demande.bebe_label")}
          subtitle={`0-2 ans · max ${maxChildren - localChildren}`}
        />
      </div>

      <div className="dm-summary">
        <span>{totalPassengers} {isRTL ? "مسافر" : "voyageur(s)"}</span>
      </div>

      <div className="dm-actions">
        <button className="dm-btn-back" onClick={onBack}>
          <FaArrowLeft /> {t("demande.back_button")}
        </button>
        <button className="dm-btn-next" onClick={handleNext}>
          {t("demande.next_button")} <FaArrowRight />
        </button>
      </div>
    </div>
  );
}
